import { useDispatch, useSelector } from 'react-redux';
import { Box, Icon } from '@quintoandar-tokko/jopijs';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import reportTranslations from '@/components/Webcontact/assignmentReport/AssignmentReport.trans.json';
import {
  ASSIGNMENT_REPORT_PATH,
  ASSIGNMENT_REPORT_ORIGIN,
} from '@/components/Webcontact/assignmentReport/constants';
import canAccessAssignmentReport from '@/components/Webcontact/assignmentReport/canAccessAssignmentReport';
import InquiriesReceivedEmptyState from './InquiriesReceivedEmptyState';
import InquiriesReceivedContent from './InquiriesReceivedContent';
import PerformanceCard from '../PerformanceCard';
import cardStyles from '../PerformanceCard/performanceCard.module.scss';
import useFetchDashboard from '../../customHooks/useFetchDashboard';
import { getPerformanceReceivedLeadsCard } from '@/store/slices/components/dashboard/service';
import { setPerformanceModals } from '@/store/slices/components/dashboard/DashboardSlice';

export default function InquiriesReceived() {
  const dispatch = useDispatch();
  const { waffle_flags: waffleFlags, allPermissions } = useSelector(
    (state) => state.AuthSlice?.permissions || {}
  );
  const canAccessReport = canAccessAssignmentReport(
    waffleFlags,
    allPermissions
  );
  const { inquiriesReceived } = useSelector((state) => state.DashboardSlice);
  const { ref, isStale, useFetchOnViewport } = useFetchDashboard();
  const { loading, hasFetched, options, selectedOption } = inquiriesReceived;
  const showEmptyState = options[selectedOption].list.length === 0;

  useFetchOnViewport(
    (query) => {
      dispatch(getPerformanceReceivedLeadsCard({ query }));
    },
    [],
    { hasFetched }
  );

  return (
    <PerformanceCard
      ref={ref}
      loading={loading || isStale}
      id="inquiries-received"
    >
      <PerformanceCard.Header
        extraActions={
          canAccessReport ? (
            <Box
              as="a"
              href={`${ASSIGNMENT_REPORT_PATH}?origin=${ASSIGNMENT_REPORT_ORIGIN.DASHBOARD_CARD_LINK}`}
              target="_blank"
              rel="noopener noreferrer"
              className={cardStyles.assignmentReportLink}
              data-testid="assignment-report-link"
              onClick={(event) => event.stopPropagation()}
            >
              {Trans(reportTranslations, 'AssignmentReport')}
              <Icon icon="icon-ir" fontSize="14px" />
            </Box>
          ) : null
        }
        handleClickTableIcon={() =>
          dispatch(
            setPerformanceModals({
              key: 'inquiriesReceived',
              subkey: 'isOpen',
              value: true,
            })
          )
        }
      >
        {Trans(translations, 'InquiriesReceived')}
      </PerformanceCard.Header>
      {showEmptyState ? (
        <InquiriesReceivedEmptyState />
      ) : (
        <InquiriesReceivedContent />
      )}
    </PerformanceCard>
  );
}
